jQuery(document).ready(function () {


   const productinfoslide = new Swiper(".productinfo-main", {
    slidesPerView: 1,
    pagination: {
      el: '.productinfo-pagination',
      clickable: true
    },
    autoplay: {
      delay: 3000, // time in ms between slides
      disableOnInteraction: false // autoplay continues after user interaction
    }
  });


    const accompagnement = new Swiper(".recommandproduct-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".recommandproduct-slider-Next",
      prevEl: ".recommandproduct-slider-Prev",
    },
    pagination: {
      el: ".accompagnement-pagination",
      clickable: true,
    },
  });


  function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1' + thousands
    );
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return format.replace(placeholderRegex, value);
}

  $(document).on('change','.btnbox-product .quantity__input',function(){
    var value = $(this).val(),
        price = $(this).attr('data-price'),
        totalPrice = parseInt(price) * parseInt(value);

    var formatString = "{{amount}} " + window.storeCurrency;

    console.log(value+' - '+' - '+price+'  '+totalPrice)
    $(document).find('.price-custom-change').text(formatMoney(totalPrice,window.shopMoneyFormat) )
  })




});

jQuery(document).ready(function ($) {
  var menuTimer;

  // Prevent default click toggle
  $(".mega-menu > summary").on("click", function (e) {
    e.preventDefault();
  });

  $(".mega-menu").on("mouseenter", function () {
    clearTimeout(menuTimer); // stop any pending close
    $(this).attr("open", true); // open immediately
  });

  $(".mega-menu").on("mouseleave", function () {
    var $menu = $(this);
    menuTimer = setTimeout(function () {
      $menu.removeAttr("open"); // close after small delay
    }, 200); // delay in ms (adjust if needed)
  });

  var hoverTimer;

  // Prevent default click behavior inside header-menu
  $("header-menu details > summary").on("click", function (e) {
    e.preventDefault();
  });

  // Handle hover open/close
  $("header-menu details").on("mouseenter", function () {
    clearTimeout(hoverTimer);
    $(this).attr("open", true);
  });

  $("header-menu details").on("mouseleave", function () {
    var $this = $(this);
    hoverTimer = setTimeout(function () {
      $this.removeAttr("open");
    }, 200); // adjust delay as needed
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Target all summary elements that have an <a> inside
  document.querySelectorAll("summary a").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.stopPropagation(); // Prevent summary toggle
      // Optional: allow normal navigation (you could also use location.href if needed)
    });
  });
});






function setDeliveryDate(forceUpdate = false) {
  const cutoffHour = 13; // 1pm
  const minDeliveryDays = 3; // délai minimum garanti
  const deliveryDays = [
    "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"
  ];
  const monthNames = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ];

  const now = new Date();
  const hour = now.getHours();

  let deliveryDate = new Date();

  function addDays(days) {
    deliveryDate.setDate(deliveryDate.getDate() + days);
  }

  if (hour < cutoffHour) {
    addDays(minDeliveryDays);
  } else {
    addDays(minDeliveryDays + 1);
  }

  const deliveryDayName = deliveryDays[deliveryDate.getDay()];
  const deliveryDateNumber = ("0" + deliveryDate.getDate()).slice(-2);
  const deliveryMonthName = monthNames[deliveryDate.getMonth()];

  const deliveryText = deliveryDayName + " " + deliveryDateNumber + " " + deliveryMonthName;

  const targetSpan = document.querySelectorAll(".deliverydatebox span");
  if (targetSpan.length) {
    targetSpan.forEach(function(span) {
      // Agar forceUpdate true hai to hamesha set karo, warna tab set karo jab empty ho
      if (forceUpdate || !span.textContent.trim()) {
        span.textContent = deliveryText;
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  setDeliveryDate(true);

  let attempts = 0;
  const interval = setInterval(() => {
    setDeliveryDate(true);
    attempts++;
    if (attempts >= 20) {
      clearInterval(interval);
    }
  }, 500);
});


document.addEventListener("DOMContentLoaded", function () {
  // Custom quantity container
  const customQuantity = document.querySelector('quantity-input.cart-quantity');
  if (!customQuantity) {
    console.log('❌ Custom quantity box not found');
    return;
  }

  const customQtyInput = customQuantity.querySelector('.quantity__input');
  const plusBtn = customQuantity.querySelector('button[name="plus"]');
  const minusBtn = customQuantity.querySelector('button[name="minus"]');

  // Main quantity container inside .price-per-item__container
  const mainQuantityContainer = document.querySelector('.price-per-item__container quantity-input.quantity');
  if (!mainQuantityContainer) {
    console.log('❌ Main quantity box not found inside .price-per-item__container');
    return;
  }

  const mainQtyInput = mainQuantityContainer.querySelector('.quantity__input');
  const mainPlusBtn = mainQuantityContainer.querySelector('button[name="plus"]');
  const mainMinusBtn = mainQuantityContainer.querySelector('button[name="minus"]');


  customQtyInput.addEventListener('input', function () {
    let val = parseInt(this.value);
    if (isNaN(val) || val < 1) val = 1;
    this.value = val;

    mainQtyInput.value = val;
    mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  plusBtn.addEventListener('click', function () {
    console.log('Custom PLUS clicked → triggering main PLUS');
    mainPlusBtn.click();
  });

  minusBtn.addEventListener('click', function () {
    console.log('Custom MINUS clicked → triggering main MINUS');
    mainMinusBtn.click();
  });
});